import CryptoApp from "./CryptoApp";
const tasks = [
  { id: "1", words: ["МОРЕ","ПЕРО","РОТ","КОМПОТ","ОТПОР","ПРОЕКТ","ПОРТРЕТ","КОМПЬЮТЕР"], cryptoKey: "отпюкьерм" },
  { id: "2", words: ["КОТ","ПОТОК","ОКОРОК","КРЕКЕР","ПЮРЕ","МОТОР","ПОТОМОК","ПРОЕКТОР"], cryptoKey: "отпюкьерм" },  
  { id: "3", words: ["БУДЕМ"], cryptoKey: "едбумоляр" },
  { id: "4", words: ["БЛЕЯЛ"], cryptoKey: "едбумоляр" },
  { id: "5", words: ["ИСКУПАЛИСЬ"], cryptoKey: "аливькпус" },
  { id: "6", words: ["ВРЕМЕННОГО"], cryptoKey: "ремавьног" },     
  { id: "7", words: ["ГИГАНТСКИМИ"], cryptoKey: "гиканотсм" },
  { id: "8", words: ["ВАРЕНЬЕМ"], cryptoKey: "ремавьног" }, 
  { id: "9", words: ["ИССЛЕДОВАЛИ"], cryptoKey: "длеовисак" },
];
const cryptoRoutes = tasks.flatMap((task) => [
  {
    path: `/crypto/${task.id}`,
    element: <CryptoApp words={task.words} cryptoKey={task.cryptoKey} random = {false}/>,
  },
  {
    path: `/crypto/${task.id}/r`,
    element: <CryptoApp words={task.words} cryptoKey={task.cryptoKey} random = {true}/>,
  },
]);
export default cryptoRoutes;
